import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' },
});

export const ADMIN_TOKEN_KEY = 'ichi_admin_token';

export const setAdminToken = (token) => {
  if (token) localStorage.setItem(ADMIN_TOKEN_KEY, token);
  else localStorage.removeItem(ADMIN_TOKEN_KEY);
};

export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY);

export const adminApi = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' },
});

adminApi.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      setAdminToken(null);
      if (!window.location.pathname.startsWith('/admin/login')) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(err);
  }
);

// Build WhatsApp pre-filled URL for hybrid notification
export const buildWhatsAppUrl = (phoneRaw, message) => {
  const cleanPhone = phoneRaw.replace(/[^0-9]/g, '');
  return `https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`;
};

export const buildAppointmentMessage = (data) => {
  return [
    '*New Appointment Request - Ichi & Ori Pet Care*',
    '',
    `Pet Parent: ${data.name}`,
    `Mobile: ${data.mobile}`,
    `Pet Name: ${data.pet_name}`,
    `Pet Type: ${data.pet_type}`,
    `Service: ${data.service}`,
    `Preferred Date: ${data.preferred_date}`,
    `Preferred Time: ${data.preferred_time}`,
    data.notes ? `Notes: ${data.notes}` : null,
  ]
    .filter(Boolean)
    .join('\n');
};

export const buildContactMessage = (data) => {
  return [
    '*New Contact Enquiry - Ichi & Ori Pet Care*',
    '',
    `Name: ${data.name}`,
    `Mobile: ${data.mobile}`,
    data.email ? `Email: ${data.email}` : null,
    data.subject ? `Subject: ${data.subject}` : null,
    '',
    `Message: ${data.message}`,
  ]
    .filter(Boolean)
    .join('\n');
};
